// extracted by mini-css-extract-plugin
module.exports = {"gallery":"bikeGallery_gallery__3L41w","image":"bikeGallery_image__3cj1H","active":"bikeGallery_active__3ppZ4"};